import IndexPage from '@/components/pages/IndexPage/IndexPage'

const Index = () => {
  return <IndexPage />
}

export default Index
